import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { App as AntdApp, Card as AntdCard } from 'antd';
import type { CardProps } from 'antd';
import App from './App';
import './index.css';
import 'leaflet/dist/leaflet.css';

/**
 * Temporary bridge for Ant Design Card deprecated `bordered` prop.
 * Some downstream modules still pass `bordered`, which now triggers warnings
 * in 5.27+. Normalize those props to the new `variant` API until they are updated.
 */
const originalCreateElement: typeof React.createElement = React.createElement;
const patchedCreateElement = ((...args: Parameters<typeof React.createElement>) => {
  const [type, props, ...children] = args;
  if (type === AntdCard && props && Object.prototype.hasOwnProperty.call(props, 'bordered')) {
    const { bordered, variant, ...restProps } = props as CardProps;
    const normalizedVariant =
      variant ?? (bordered === false ? 'borderless' : 'outlined');

    return originalCreateElement(type, { ...restProps, variant: normalizedVariant }, ...children);
  }

  return originalCreateElement(type, props, ...children);
}) as typeof React.createElement;

React.createElement = patchedCreateElement;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <AntdApp>
        <App />
      </AntdApp>
    </HelmetProvider>
  </React.StrictMode>
);
